import * as React from "react";
import { ButtonLabels } from "../../Resource/Contents";
import { ClientDetail } from "./ClientDetail";
import { ContactDetail } from "./ContactDetail";
import { IAddClientModel, Journey } from "../AddClientWizard";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../../Urls";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { CustomerMatching } from "../CustomerMatching/CustomertMatching";
import { CustomerMatchingAction } from "../../Actions/CustomerMatchingAction";
import { CustomerSearchModel } from "../../../../../../../Wrap/Models/Models/Customer/CustomerSearch/CustomerSearchModel";
import { CustomerType } from "../../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { validationMessage } from "../../Resource/Validation";
import { UserStore } from "../../../../../Stroes/Variable";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import AdviserSiteTagManager from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { CustomerNameFuzzySearchClient } from "../../../../../../../Wrap/Api/Customer/CustomerNameFuzzySearch";
import { PhysicalAddressType } from "../../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { RoleType } from "../../../../../../../Wrap/Constants/Enums/RoleType";
import { SearchInput } from "../../../../../../Shared/SearchInput/SearchInput";
import { Table } from "../../../../../../Shared/Table/Table";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { NewBusinessAction } from "../../../NewBusinessWizard/Actions/NewBusinessAction";
import { AccountRoleType } from "../../../../../../../Wrap/Models/Domains/Customers/AccountRoleType";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { CustomerTaxResidencyModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { ContentDatePicker, ACCEPT_DATE_FORMATS } from "../../../../../../Shared/Entities/Constants/DateConstants";
import { TitleMap } from "../../../../../../Shared/Entities/Maps/TitleMap";
import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { Gender } from "../../../../../../../Wrap/Constants/Enums/Domain/Gender";
import { GenderOptions, GuardianGenderOptions, GenderOptionsMap } from "../../../NewBusinessWizard/Resource/Contents";
import { getAgefromDateOfBirth } from "../../../../../../Shared/Utils/getAgefromDateOfBirth";
import { Objects } from "../../../../../../../react-core/Utils/Objects";

interface IChildDetailsProps extends IProcessComponentProps {
    data: IAddClientModel;
    onSubmit: (journeyType: Journey) => void;
}

interface IChildDetailsState {
    isOpen: boolean;
    isCustomerMatchingOpen: boolean;
    customerMatchingResult: CustomerSearchModel;
    journeyType: Journey;
    roleSelected: AccountRoleType;
    clientPortalAccess: boolean;
    customerSelected: FullClientDetailModel;
    adviserId: number;
    UseAddressForCorrespondence?: boolean;
    residencies: CustomerTaxResidencyModel[];
    nationalities: CustomerTaxResidencyModel[];
    hasCorrespondenceAddress: boolean;
}

export class ChildDetails extends ProcessComponent<IChildDetailsProps, IChildDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isOpen: false,
            isCustomerMatchingOpen: false,
            customerMatchingResult: null,
            journeyType: null,
            roleSelected: null,
            clientPortalAccess: null,
            customerSelected: null,
            adviserId: null,
            UseAddressForCorrespondence: null,
            residencies: [],
            nationalities: [{ IsNationality: true }],
            hasCorrespondenceAddress: true,
        };
    }

    private naviagetToPreviousPage() {
        Navigator.navigateToAndPreserveQueryParameters(Urls.get().ClientType);
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentDidMount() {
        super.componentDidMount();
        this.addEvent({
            environment: {
                appType: "web",
                setting: "prod",
                timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
            },
            page: {
                pageUrl: window.location.pathname,
                pageTitle: `${document.title} - add new client - cliet details`,
            },
            user: {
                loginId: UserStore.getUserInfo()?.ClientId.toString(),
                internal: "yes",
            },
            event: "pageLoaded",
        });
        this.setState({ roleSelected: { RoleType: RoleType.RegisteredContact } });
    }

    private getCustomerMatchingData(pageIndex, pageSize) {
        const { data } = this.props;
        CustomerMatchingAction.getMatchingCustomers(
            data.Prospect.FirstName,
            data.Prospect.Surname,
            data.Prospect.DateOfBirth,
            data.Prospect.OwnerAdviserId,
            pageIndex,
            pageSize,
            (result: CustomerSearchModel) => {
                if (result.CustomerList && result.CustomerList?.length > 0) {
                    this.setState({ isCustomerMatchingOpen: true, customerMatchingResult: result });
                } else {
                    this.props.onSubmit(this.state.journeyType);
                }
            }
        );
    }

    isValid() {
        const data: IAddClientModel = this.props.data;
        let flag = super.isValid();
        if (!data?.Prospect?.FirstName) {
            this.props.showErrorMsgPopUp([validationMessage.firstNameValidation], true);
            flag = false;
        }
        if (!data?.Prospect?.Surname) {
            this.props.showErrorMsgPopUp([validationMessage.surnameValidation], true);
            flag = false;
        }
        if (!data?.Prospect?.DateOfBirth) {
            this.props.showErrorMsgPopUp([validationMessage.dateOfBirthValidation], true);
            flag = false;
        }

        if (
            data?.Prospect?.DateOfBirth &&
            getAgefromDateOfBirth(JsonDateParser.toDateNoOffset(data?.Prospect?.DateOfBirth)) >= 18
        ) {
            this.props.showErrorMsgPopUp([validationMessage.dateOfBirthIndividualValidation], true);
            flag = false;
        }

        if (!this.state.customerSelected) {
            this.props.showErrorMsgPopUp([validationMessage.GuardianValidation], true);
            flag = false;
        }
        else if (
            this.state.customerSelected?.PersonalDetails.DateOfBirth &&
            getAgefromDateOfBirth(
                JsonDateParser.toDateNoOffset(this.state.customerSelected?.PersonalDetails?.DateOfBirth)
            ) < 18
        ) {
            this.props.showErrorMsgPopUp([validationMessage.dateOfBirthGuardianValidation], true);
            flag = false;
        }

        return flag;
    }

    private submitClient(journeyType: Journey) {
        if (this.isValid()) {
            this.setState({ journeyType: journeyType });
            this.getCustomerMatchingData(1, 10);
        }
    }

    private onPageChange(pageIndex, pageSize) {
        this.getCustomerMatchingData(pageIndex, pageSize);
    }

    private onDismissCustomerMatchings() {
        this.props.onSubmit(this.state.journeyType);
    }

    renderCustomerSearch() {
        const client = new CustomerNameFuzzySearchClient();
        return (
            <>
                <h3>Add Parent/Legal Guardian</h3>
                <SearchInput
                    apiClient={(v) => {
                        return client.get(
                            v,
                            this.props.data?.Prospect?.OwnerAdviserId,
                            this.state.roleSelected?.RoleType
                        );
                    }}
                    minLength={3}
                    customeChildren={(data) => this.transformInputSearch(data)}
                    cssWrapper="mb-35 control-size-430"
                />
            </>
        );
    }

    private transformInputSearch(data: any) {
        const newData: Array<any> = Objects.cloneObject(data).filter(
            (x) => getAgefromDateOfBirth(JsonDateParser.toDateNoOffset(x.DateOfBirth)) > 18
        );

        if (newData) {
            let customeChildren = (
                <Table
                    data={newData}
                    col={[
                        {
                            title: "Client",
                            key: "Name",
                            render: (data, row, index) => {
                                return <span>{row.FirstName + " " + row.LastName}</span>;
                            },
                        },
                        {
                            title: "Date of birth",
                            key: "DateOfBirth",
                            render: (data, row, index) => {
                                return JsonDateParser.getFormatDateString(new Date(data), "dd MM yyyy", true);
                            },
                        },
                        {
                            title: "Assigned adviser",
                            key: "OwnerAdviserId",
                        },
                        {
                            title: "",
                            key: "",
                            render: (data, row) => {
                                return this.renderAddClientButtonWithToggleStyle(row);
                            },
                        },
                    ]}
                    showEmptyMsg={true}
                />
            );
            return customeChildren;
        }
    }

    private renderAddClientButtonWithToggleStyle(row: any): JSX.Element {
        const isThisClientAlreadySelected =
            this.state.customerSelected != null && this.state.customerSelected.ActorId == row.ActorId;

        if (isThisClientAlreadySelected) {
            return (
                <div className="wizard-stepper">
                    <ul className="steps">
                        <li className="done">
                            <div className="ws-1-link"></div>
                        </li>
                    </ul>
                </div>
            );
        }

        return (
            <button className="secondary-add-button" onClick={() => this.addClient(row)}>
                <span className="text">+ add client</span>
            </button>
        );
    }

    private addClient(row: any) {
        NewBusinessAction.getCustomerData(row?.ActorId, (data) => {
            const hasPostalAddress = data.AddressDetails?.find(
                (ele) => ele.PhysicalAddressType == PhysicalAddressType.Postal
            );
            if (!data.ActorUserId) {
                this.setState({ clientPortalAccess: false });
            } else if (data?.ActorUserId > 0) {
                this.setState({ clientPortalAccess: true });
            }
            let initArray = [];
            if (hasPostalAddress) {
                this.setState({ customerSelected: data, UseAddressForCorrespondence: false }, () =>
                    this.onCCMChange(initArray)
                );
            } else {
                this.setState({ customerSelected: data }, () => this.onCCMChange(initArray));
            }
            this.setState({ nationalities: data.CustomerTaxResidencyDetails });
            this.setState({ residencies: data.CustomerTaxResidencyDetails });
        });

        this.onDataChange(
            this.props.onChange,
            {
                PrimaryActorId: row?.ActorId,
                RelationshipType: RelationshipType.Guardian,
            },
            this.props.data,
            "Prospect"
        );
    }

    private onCCMChange = (changes: { value: any; path: string }[]) => {
        const { customerSelected } = this.state;
        let _model = { ...customerSelected };
        changes.forEach((change) => {
            _model = setValueByKey(_model, change.path, change.value);
        });
        this.setState({ customerSelected: _model });
    };

    onCorrespondenceAddressChange(val): void {
        this.setState({ hasCorrespondenceAddress: val });
    }

    private renderClientDetails() {
        const roleType = this.state.roleSelected?.RoleType;
        const data = this.state.customerSelected;
        return (
            <>
                <SelectEditor
                    options={TitleMap.getArray()}
                    cssWrapper="control-size-180"
                    selected={data.PersonalDetails?.Title}
                    label={"Title"}
                    getText={(option) => TitleMap.getString(option)}
                    onChange={(v) => this.onCCMChange([{ value: v, path: "PersonalDetails.Title" }])}
                    placeholder={"Please select"}
                    disabled={true}
                />
                <TextBoxEditor
                    cssWrapper="control-size-430"
                    value={data.PersonalDetails?.GivenName}
                    label={"First name"}
                    onChange={(v) => this.onCCMChange([{ value: v.trim(), path: "PersonalDetails.GivenName" }])}
                    disabled={true}
                />
                <TextBoxEditor
                    cssWrapper="control-size-430"
                    value={data.PersonalDetails?.FamilyName}
                    label={"Surname"}
                    onChange={(v) => this.onCCMChange([{ value: v.trim(), path: "PersonalDetails.FamilyName" }])}
                    disabled={true}
                />
                <DatePicker
                    label={"Date of birth"}
                    formGroupCssWrapper={"control-size-430"}
                    selected={JsonDateParser.toDateNoOffset(data?.PersonalDetails?.DateOfBirth)}
                    alwaysValidateOnUpdate={false}
                    atLeast={{
                        value: new Date(new Date().setFullYear(new Date().getFullYear() - 120)),
                        errorMessage: ContentDatePicker.CannotBeInThePast,
                    }}
                    atMost={{
                        value: new Date(),
                        errorMessage: ContentDatePicker.CannotBeInTheFuture,
                    }}
                    showYearDropdown={true}
                    onChange={(v) => {
                        this.onCCMChange([
                            {
                                value: JsonDateParser.toJsonDateNoOffset(v),
                                path: "PersonalDetails.DateOfBirth",
                            },
                        ]);
                    }}
                    todayButton={ContentDatePicker.Today}
                    isClearable={true}
                    dateFormat={ContentDatePicker.DateFormat}
                    acceptDateFormats={ACCEPT_DATE_FORMATS}
                    disabled={true}
                />
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label="Gender"
                    options= {GuardianGenderOptions}
                    getText={(v) => {
                        return GenderOptionsMap[v];
                    }}
                    onChange={(v) => {
                        this.onCCMChange([{ value: v, path: "PersonalDetails.Gender" }]);
                    }}
                    selected={
                        data.PersonalDetails?.Gender == Gender.Female
                            ? GenderOptions[1]
                            : data.PersonalDetails?.Gender == Gender.Male
                            ? GenderOptions[0]
                            : null
                    }
                    disabled={true}
                />
                <TextBoxEditor
                    cssWrapper="col-max-430"
                    value={data.EmailAddressDetails[0]?.EmailAddress}
                    label={"Email address"}
                    inputMode={"email"}
                    disabled={true}
                />
            </>
        );
    }

    renderAlert() {
        if (
            this.props.data?.Prospect?.DateOfBirth &&
            JsonDateParser.calculateAge(this.props.data?.Prospect?.DateOfBirth) < 18
        ) {
            return (
                <Alert
                    alertType={AlertType.Warning}
                    message="The Date Of Birth entered indicates this is an individual younger than 18 years old, please add a parent/legal guardian to attach to this individual. Please note, the adult must already exist on the Aberdeen platform."
                />
            );
        }
    }

    render() {
        const { data, onChange } = this.props;

        return (
            <>
                <h2>{"Child details"}</h2>
                {data.CustomerType === CustomerType.Child && (
                    <>
                        <ClientDetail
                            data={data && data.Prospect ? data.Prospect : {}}
                            onChange={(changes) => {
                                this.onDataChange(onChange, changes, data, "Prospect");
                            }}
                            onRef={(ref) => this.appendChild(ref)}
                        />

                        {this.renderAlert()}

                        <ContactDetail
                            data={data && data.Prospect ? data.Prospect : {}}
                            customerType = {CustomerType.Child}
                            onChange={(changes) => {
                                this.onDataChange(onChange, changes, data, "Prospect");
                            }}
                            onRef={(ref) => this.appendChild(ref)}
                        />

                        {this.renderCustomerSearch()}

                        {this.state.customerSelected && this.renderClientDetails()}
                    </>
                )}

                <div className="page-actions">
                    <div className="action-secondary">
                        <button
                            onClick={() => {
                                this.naviagetToPreviousPage();
                            }}
                            className="prev-button"
                        >
                            <span aria-hidden="true" className="icon"></span>
                            <span className="text">{ButtonLabels.previousLabel}</span>
                        </button>
                    </div>
                    <div className="action-primary">
                        <div className="primary-dropdown">
                            <button
                                className="trigger"
                                aria-expanded={this.state.isOpen}
                                aria-haspopup="true"
                                onClick={() =>
                                    this.updateStatePart((x) => {
                                        x.isOpen = !this.state.isOpen;
                                    })
                                }
                            >
                                <span className="text">{ButtonLabels.nextLabel}</span>
                                <span className="icon" aria-hidden="true"></span>
                            </button>
                            {this.state.isOpen && (
                                <div className="dropdown-list a-dropdown-enter-done">
                                    <div className="dropdown-list-panel">
                                        <button className="item" onClick={() => this.submitClient(Journey.AddClient)}>
                                            {ButtonLabels.addClient}
                                        </button>
                                        <button className="item" onClick={() => this.submitClient(Journey.Quote)}>
                                            {ButtonLabels.quote}
                                        </button>
                                        <button className="item" onClick={() => this.submitClient(Journey.NewBusiness)}>
                                            {ButtonLabels.newBusiness}
                                        </button>
                                        <button
                                            className="item"
                                            onClick={() => this.submitClient(Journey.CreateAnotherClient)}
                                        >
                                            {ButtonLabels.createAnotherClient}
                                        </button>
                                    </div>
                                </div>
                            )}
                            {this.state.isCustomerMatchingOpen && (
                                <Lightbox
                                    show={this.state.isCustomerMatchingOpen}
                                    title={"Client matches"}
                                    contentAfterTitle={null}
                                    onClose={() => this.setState({ isCustomerMatchingOpen: false })}
                                    type={LightboxType.Modal}
                                    unclosable={true}
                                    noOverlay={false}
                                    noAutofocus={true}
                                    cssWrapper="is-default-lightbox"
                                >
                                    <CustomerMatching
                                        data={this.state.customerMatchingResult}
                                        onPageChange={(pageIndex, pageSize) => this.onPageChange(pageIndex, pageSize)}
                                        onDismissMatches={() => this.onDismissCustomerMatchings()}
                                        displayChooseClientOption={false}
                                    ></CustomerMatching>
                                </Lightbox>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
